import { Divider as DividerMui } from '@mui/material';
import { Spacing } from '../../design-system/spacing';
import { styled } from '../../utils/styled';

export const StyledDivider = styled(DividerMui, {
  shouldForwardProp: (prop: string) =>
    !['light', 'fullWidth', 'noMargin'].includes(prop),
})<{ light?: boolean; fullWidth?: boolean; noMargin?: boolean }>`
  margin: ${({ noMargin }) => (noMargin ? 'unset' : '10px 0')};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'unset')};
  border-color: ${({ light, theme }) =>
    light ? theme.palette.neutral[200] : theme.palette.neutral[800]};

  &.MuiDivider-root {
    margin-top: ${({ noMargin }) => (noMargin ? 'unset' : Spacing.Small)};
    margin-bottom: ${({ noMargin }) => (noMargin ? 'unset' : Spacing.Small)};
  }
`;

export const StyledVerticalDivider = styled(DividerMui, {
  shouldForwardProp: (prop: string) => !['light', 'noMargin'].includes(prop),
})<{ light?: boolean; noMargin?: boolean }>`
  margin: ${({ noMargin }) => (noMargin ? 'unset' : '0 10px')};
  width: 1px !important;
  background-color: ${({ theme, light }) =>
    light ? theme.palette.neutral[200] : theme.palette.neutral[800]} !important;
  border: none !important;
  align-self: stretch;

  &.MuiDivider-root {
    margin-left: ${({ noMargin }) => (noMargin ? 'unset' : Spacing.Small)};
    margin-right: ${({ noMargin }) => (noMargin ? 'unset' : Spacing.Small)};
    margin-top: unset;
    margin-bottom: unset;
    border: none !important;
    border-color: transparent !important;
  }

  &::before,
  &::after {
    display: none;
  }
`;
